import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  RollPlusUpgradable,
  UpgradableNumber
} from "@dndModels";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import StringBox from "@components/input/strings/StringBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

interface Props {
  obj: RollPlusUpgradable;
  disabled?: boolean;
  change_time?: number;
  onChange: (changed: RollPlusUpgradable) => void;
}

export default function RollPlusUpgradableInput({ 
  obj,
  onChange,
  change_time = 0,
  disabled = false 
}: Props) {
  const [basic, setBasic] = useState(obj.flat.isBasic() && obj.count.isBasic() && obj.size.isBasic());
  const [prev_change_time, setChangeTime] = useState(change_time);

  useEffect(() => {
    if (change_time !== prev_change_time) {
      setChangeTime(change_time);
    }
  }, [change_time, prev_change_time, setChangeTime]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 3
        }}>
        <ToggleButtonBox 
          name="Basic"
          value={basic} 
          disabled={disabled}
          onToggle={() => {
            if (!basic) {
              const new_obj = obj;
              new_obj.flat.makeBasic();
              new_obj.count.makeBasic();
              new_obj.size.makeBasic();
              onChange(new_obj);
            }
            setBasic(!basic);
          }}
        />
      </Grid>
      { basic ? 
        <Grid
          size={{
            xs: 3
          }}>
          <StringBox 
            name="Dice Count"
            value={`${obj.count.base}`} 
            disabled={disabled}
            type="number"
            onChange={(value: string) => {
              const new_obj = obj;
              new_obj.count.base = +value;
              onChange(new_obj);
            }}
          />
        </Grid>
      :
        <Grid
          size={{
            xs: 3
          }}>
          <UpgradableNumberBox 
            name="Dice Count"
            value={obj.count} 
            disabled={disabled}
            onChange={(value: UpgradableNumber) => {
              const new_obj = obj;
              new_obj.count = value;
              onChange(new_obj);
            }}
          />
        </Grid>
      }
      { basic ? 
        <Grid
          size={{
            xs: 3
          }}>
          <StringBox 
            name="Dice Size"
            value={`${obj.size.base}`} 
            disabled={disabled}
            type="number"
            onChange={(value: string) => {
              const new_obj = obj;
              new_obj.size.base = +value;
              onChange(new_obj);
            }}
          />
        </Grid>
      :
        <Grid
          size={{
            xs: 3
          }}>
          <UpgradableNumberBox 
            name="Dice Size"
            value={obj.size} 
            disabled={disabled}
            onChange={(value: UpgradableNumber) => {
              const new_obj = obj;
              new_obj.size = value;
              onChange(new_obj);
            }}
          />
        </Grid>
      }
      { basic ? 
        <Grid
          size={{
            xs: 3
          }}>
          <StringBox 
            name="Flat"
            value={`${obj.flat.base}`} 
            disabled={disabled}
            type="number"
            onChange={(value: string) => {
              const new_obj = obj;
              new_obj.flat.base = +value;
              onChange(new_obj);
            }}
          />
        </Grid>
      :
        <Grid
          size={{
            xs: 3
          }}>
          <UpgradableNumberBox 
            name="Flat"
            value={obj.flat} 
            disabled={disabled}
            onChange={(value: UpgradableNumber) => {
              const new_obj = obj;
              new_obj.flat = value;
              onChange(new_obj);
            }}
          />
        </Grid>
      }
    </Grid>
  );
}
